export const TEACHING_LANGUAGES = {
  en: "English",
  es: "Spanish",
};
